export default {
  data() {
    return {};
  },

  methods: {
    getFileNameFromResponseContentDisposition(response) {
      const contentDisposition = response.headers['content-disposition'];
      var fileName = "";
      if (contentDisposition.includes('filename="')) {
        fileName = contentDisposition.split('filename="')[1].split('";')[0];
      }
      else {
        fileName = contentDisposition.split('filename=')[1].split(';')[0];
      }
      return fileName;
    },

    saveBlobToFile(blob, filename) {
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename || "download";
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    },

    async printBlobData(blobData) {
      const blob = new Blob([blobData], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);

      // print via hidden iframe (no file saved)
      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.right = "0";
      iframe.style.bottom = "0";
      iframe.style.width = "0";
      iframe.style.height = "0";
      iframe.style.border = "0";
      iframe.src = blobUrl;

      // --- robust cleanup helpers ---
      const cleanup = () => {
        try { URL.revokeObjectURL(blobUrl); }
        catch (e) {
          console.log(e)
        }
        if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
        window.removeEventListener("afterprint", onAfterPrintWin);
        if (iframe.contentWindow) {
          iframe.contentWindow.removeEventListener("afterprint", onAfterPrintFrame);
          const mm = iframe.contentWindow.matchMedia && iframe.contentWindow.matchMedia("print");
          if (mm && mm.removeListener) mm.removeListener(onMediaChange);
        }
        clearTimeout(fallbackTimer);
      };

      const onAfterPrintFrame = () => cleanup();
      const onAfterPrintWin = () => cleanup();
      const onMediaChange = (mql) => {
        // Some browsers toggle mql.matches around print; when it switches back, we're done.
        if (!mql.matches) cleanup();
      };

      const fallbackTimer = setTimeout(() => cleanup(), 120000); // 2 min safety net

      iframe.onload = () => {
        try {
          // Wire up afterprint on the iframe document (best signal)
          if (iframe.contentWindow) {
            iframe.contentWindow.addEventListener("afterprint", onAfterPrintFrame, { once: true });

            // Extra safety: media query listener for browsers that don't fire afterprint reliably
            if (iframe.contentWindow.matchMedia) {
              const mm = iframe.contentWindow.matchMedia("print");
              if (mm && mm.addListener) mm.addListener(onMediaChange);
            }

            // Also listen on parent window (some engines bubble differently)
            window.addEventListener("afterprint", onAfterPrintWin, { once: true });

            // Kick off print
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
          }
        } catch (e) {
          // Fallback: open in a new tab; user hits Ctrl/Cmd+P manually
          const w = window.open(blobUrl, "_blank");
          if (!w) console.warn("Popup blocked — could not open print preview.");
          // Cleanup will still run via fallback timer.
        }
      };

      document.body.appendChild(iframe);

      // Safari/iOS sometimes doesn't fire onload for PDFs → tiny nudge
      setTimeout(() => {
        try {
          if (iframe.contentWindow && !iframe.contentWindow.printCalled) {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
          }
        } catch (e) {
          console.error(e);
        }
      }, 1200);
    },
  },

  computed: {},

  watch: {},
}